export default {
  expoName: "Personal account",
  expoNameManager: "Manager personal account",
  expoBrandName: "EXPOCENTRE",

  email: "E-mail",
  password: "Password",
  repeatPassword: "Password confirmation",
  lastName: "Last name",
  firstName: "First name",
  middleName: "Middle name",
  phone: "Mobile phone",
  jobPosition: "Your job position",
  companyName: "Company name",
  companyWebsite: "Company website",
  birthday: "Birthday",
  birthplace: "Birth place",
  requiredFields: "Required fields",

  header: {
    myExhibitions: "My exhibitions",
    support: "Support",

    profileEdit: "Edit profile account",
    profileLogout: "Log out"
  },

  footer: {
    helplineOpenHours: "daily, 8AM — 8PM",
    callbackRequest: "Request a call back",
    privatePolicy: "Personal Data Processing POLICY of EXPOCENTRE AO"
  },

  addEventBtn: "Add exhibition",
  contactUsBtn: "Write to us",

  addEventCardGo: "View exhibition",

  eventCardGo: "View",
  eventCardLook: "Look",

  addBtn: "Add",
  addingBtn: "Adding...",
  addedBtn: "Added",

  saveBtn: "Save",
  savingBtn: "Saving...",
  savedBtn: "Saved",

  editBtn: "Edit",
  fillBtn: "Fill in",
  lookBtn: "Look",

  submitBtn: "Submit",
  selectBtn: "Select",

  cancelBtn: "Cancel",
  cancel: "Cancel",
  deleteBtn: "Delete",
  closeBtn: "Close",
  ok: "OK",

  validationError: "Not all fields are filled",

  addMore: "Add more",

  loading: "Loading...",

  inn: "Registration №",
  notFoundPage: "Unfortunately, this page does not exist",
  goToExhib: "Go to main page",
  error: "A technical error has occurred on the server.",
  errorFront: "An error has occurred, please try again."
};
